@if (customersEmails && loaded) {
  <div class="dynamic-modal-popup" (click)="close($event)">
    @if (!templateStage) {
      <div class="dynamic-modal-content">
        <h3 class="pr-s pl-s">Bitte wählen Sie einen Empfänger</h3>
        <div class="custom-email-add pl-s pr-s">
          <input type="text" placeholder="Fügen Sie Ihre E-Mail hinzu" [(ngModel)]=customEmail>
          <button class="short-btn green" (click)="addCustomEmail()">Hinzufügen</button>
        </div>
        <ul class="email-list">
          @if (keyContact) {
            <li class="bg-light-green b-radius p-xs m-xs">
              <input class="custom-checkbox green big" type="checkbox" [id]="keyContact.id" [(ngModel)]="keyContact.active">
              <label [for]="keyContact.id">
                <span class="am-flex-align">
                  @if (keyContact.last_name) { <div>{{ keyContact.name }}</div> }
                  <div class="mobile-hide key-contact mla font-s color-disabled">Hauptkontakt</div>
                </span>
                {{ keyContact.email }}
              </label>
            </li>
          }
          @for (customer of customersEmails; track customer) {
            <li class="pl-s pr-s ml-xxs">
              <input class="custom-checkbox blue big" type="checkbox" [id]="customer.id" [(ngModel)]="customer.active">
              <label [for]="customer.id">
                @if (customer.last_name) { <span>{{customer.name}} </span> }
                <div class="mr-xxs">{{customer.email}}</div>
              </label>
            </li>
          }
        </ul>
        @if (assignment_id && !customersEmails.length && loaded) { <p class="text-center">Dieser Kunde hat keine aktivierten Accounts für das Portal.</p> }
        <div class="modal-btn-group pl-s pr-s">
          <button class="wide-btn back-btn" (click)="close()">Abbrechen</button>
          <button class="wide-btn blue" (click)="selectTemplate()" [disabled]="!activeEmails().length">Weiter</button>
        </div>
      </div>
    }
    @if (templateStage) {
      <div class="dynamic-modal-content small">
        <h3 class=" pl-s pr-s ">Bitte wählen Sie Ihr Thema</h3>
        <div class="checkbox-wrapper  pl-s pr-s">
          <input type="radio" class="custom-checkbox radio blue big" name="email_template" id="email_template_1" value="informational" [(ngModel)]="emailTemplate">
          <label for="email_template_1">zur Kenntnisnahme</label>
        </div>
        <div class="checkbox-wrapper  pl-s pr-s">
          <input type="radio" class="custom-checkbox radio blue big" name="email_template" id="email_template_2" value="request_for_approval" [(ngModel)]="emailTemplate">
          <label for="email_template_2">zur Freigabe</label>
        </div>
        <div class="modal-btn-group  pl-s pr-s">
          <button class="wide-btn back-btn" (click)="back()">Abbrechen</button>
          <button class="wide-btn blue" (click)="sendEmail()" [disabled]="!emailTemplate">Senden</button>
        </div>
      </div>
    }
  </div>
}
